/******/ (() => { // webpackBootstrap
/*!*********************************************!*\
  !*** ./_build/scripts/snippets/quantity.js ***!
  \*********************************************/
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="quantity"]');
    this.minusBtn = this.querySelector('[name="minus"]');
    this.plusBtn = this.querySelector('[name="plus"]');

    this.minusBtn.addEventListener('click', () => this.step(-1));
    this.plusBtn.addEventListener('click', () => this.step(1));
    this.input.addEventListener('change', () => this.clamp());
  }

  step(direction) {
    const stepSize = Number(this.input.step) || 1;
    this.input.value = Number(this.input.value) + direction * stepSize;
    this.clamp();
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  clamp() {
    const min = Number(this.input.min) || 1;
    const max = this.input.max ? Number(this.input.max) : Infinity;
    const step = Number(this.input.step) || 1;
    let val = Number(this.input.value);

    val = Math.max(min, Math.min(max, val));
    // Snap to nearest valid step from min
    val = Math.round((val - min) / step) * step + min;

    this.input.value = val;
    this.minusBtn.disabled = val <= min;
    this.plusBtn.disabled = val >= max;
  }
}

customElements.define('quantity-input', QuantityInput);

/******/ })()
;